import styled from 'styled-components';

export const Wrapper = styled.div`
  .check-fields {
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
  }
  .form-actions {
    margin-top: 30px;

    & > * {
      margin-right: 20px;
    }
  }
`;
